import React, { useState, useEffect, useContext, useMemo } from "react";
import { LuEye, LuTrash2, LuSearch, LuPencil } from "react-icons/lu";
import masterApi from "../../../services/masterApi";
import { useHeaderTitle } from '../../../components/layout/layout';
import './user.scss';
import UserListComponent from '../../../components/masters/user/userList';
import RoleListComponent from '../../../components/masters/role/roleList';
import { FunctionalityNames } from "../../../enum/enum";
import { getPermissionRights} from "../../../utils/common";
import { AuthContext } from "../../../context/AuthContext";
import { ThreeDotLoader } from "../../../components/Loader/Loader"; // Add this import
import { RoleContextProvider } from "../../../components/masters/role/roleContext";

export default function UserList() {
    const { rolePermissions } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [userListPerm, setUserListPerm] = useState({});

    const [activeTab, setActiveTab] = useState("users");
    const { setHeaderTitle } = useHeaderTitle();
    useEffect(() => {
        setHeaderTitle("User Management");
    }, []);
    useEffect(() => { 
        if (rolePermissions) {
          setUserListPerm(getPermissionRights(rolePermissions, FunctionalityNames.USERS));
        }
    }, [rolePermissions]);

    return userListPerm?.view === 1 && ( 
        <section>
            {isLoading && <ThreeDotLoader />} {/* Loader overlay */}
            <div className="tabs mb-4 position-relative d-flex gap-4 pt-2">
                <button
                    className={`tab ${activeTab === "users" ? "active" : ""}`}
                    onClick={() => setActiveTab("users")}
                >
                    Users
                </button>
                <button
                    className={`tab ${activeTab === "roles" ? "active" : ""}`}
                    onClick={() => setActiveTab("roles")}
                >
                    Roles
                </button>
            </div>
            <div className="tab-content user-content position-relative">
                {activeTab === "users" && <div><UserListComponent setIsLoading={setIsLoading}/></div>}
                <RoleContextProvider>
                    {activeTab === "roles" && <div><RoleListComponent setIsLoading={setIsLoading} /></div>}
                </RoleContextProvider>
            </div>


        </section>
    );
}
